import { render, staticRenderFns } from "./enrollment-sum.vue?vue&type=template&id=6c0ed107&"
import script from "./enrollment-sum.vue?vue&type=script&lang=js&"
export * from "./enrollment-sum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "enrollment-sum.vue"
export default component.exports